import { get, keyBy, mapValues } from 'lodash';
import { DataSourcePublic } from './types';

// Used for names, descriptions etc. that have sources that are not controlled from DB (yet)
const sourcesInOrder = [
  // manual sources
  'asiakastieto',
  'manually-modified',
  'website',
  'company-website',
  'annual-report',
  'manual_eero_wikipedia',
  'yahoo-finance',
  'cdk global',
  'news',
  // bulk import sources
  'maria01',
  'insideview',
  'fortune500',
  'te-500',
  'wikipedia',
  'wikipedia-en',
  'wikipedia-fi',
  'wikipedia-sv',
  'wikipedia-de',
  'wikipedia-fr',
];

export const sourcesWithPriorities: DataSourcePublic[] = sourcesInOrder.map((source, index) => {
  return {
    id: source,
    name: source,
    priority: index,
  };
});

const priorityBySource = mapValues(
  keyBy(sourcesWithPriorities, s => s.name),
  s => s.priority,
);

export function getPriorityForDescriptionSource(source: string): number {
  return get(priorityBySource, source, Number.MAX_SAFE_INTEGER);
}

export function isManualProductSetSource(source: string) {
  return source.startsWith('manual');
}

export function isGptProductSetSource(source: string) {
  return source.startsWith('gpt');
}

export function isMicroworkProductSetSource(source: string) {
  return source.startsWith('microwork');
}

export function isTestProductSetSource(source: string) {
  return source.startsWith('test');
}
